module.exports = __webpack_public_path__ + "static/search_1-bdb1f167f063ee50998d8c14306dbd4d.jpg";